import Log from "sap/base/Log";
import { TokenResponse } from "../model/models";
import { EnvironmentService } from "./Environment.service";
import { JwtService } from "./Jwt.service";
import { ErrorHandler } from "./ErrorHandler.service";

export default class AzureTokenService {
  private azureTokenCacheKey = "azure_speech_token";

  private logger = Log.getLogger("com.unitrade.crm.speech.SpeechService");

  public async getAuthorizationToken(): Promise<TokenResponse> {
    try {
      const azureSpeechToken = this.getTokenFromLocalStorage();
      let result;

      if (!this.isTokenValid(azureSpeechToken)) {
        this.clearToken();
        this.logger.info("Speech token invalid, retrieving new one...");
        result = await this.loadAuthorizationTokenFromBackend();
        localStorage.setItem(this.azureTokenCacheKey, JSON.stringify(result));
      } else {
        result = azureSpeechToken;
      }

      return result;
    } catch (ex: any) {
      this.clearToken();
      ErrorHandler.handleError(ex, { message: "Fehler beim Laden des Azure Tokens" });
      return null;
    }
  }

  private getTokenFromLocalStorage(): TokenResponse {
    const storeval = localStorage.getItem(this.azureTokenCacheKey);
    if (!storeval) return null;

    let token: TokenResponse = null;
    try {
      token = JSON.parse(storeval);
    } catch (ex: any) {
      this.clearToken();
      this.logger.error(ex);
    }

    return token;
  }

  private isTokenValid(token: TokenResponse): boolean {
    if (!token) return false;

    if (!token.token) return false;

    const parsedToken = JwtService.parseJwt(token.token);

    return parsedToken.exp > Date.now() / 1000;
  }

  public clearToken() {
    localStorage.removeItem(this.azureTokenCacheKey);
  }

  private async loadAuthorizationTokenFromBackend(): Promise<TokenResponse> {
    const baseUrl = EnvironmentService.getBaseUrl();
    return await $.ajax({
      type: "GET",
      url: baseUrl + "/azure/get-speech-token",
    });
  }
}
